import * as types from './types';

export const setSelectedEvent = (event) => ({
  type: types.SET_SELECTED_EVENT,
  event,
});

export const toggleShowAlerts = (status: boolean) => ({
  type: types.TOGGLE_SHOW_ALERTS,
  status,
});

export const setSharingState = (state) => ({
  type: types.SET_SHARING_STATE,
  state,
});

export const setMatchingAlerts = (alerts) => ({
  type: types.SET_MATCHING_ALERTS,
  alerts,
});
